import { render, staticRenderFns } from "./OutOfBeta.vue?vue&type=template&id=1d5e96e3&"
import script from "./OutOfBeta.vue?vue&type=script&lang=js&"
export * from "./OutOfBeta.vue?vue&type=script&lang=js&"
import style0 from "./OutOfBeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports